import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CookiePolicyComponent {
  constructor(public dialogRef: MatDialogRef<CookiePolicyComponent>) {}

  cancel(): void {
    this.dialogRef.close();
  }
}
